import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import AppRouter from './router/AppRouter';
import reportWebVitals from './reportWebVitals';
import GlobalDialogProvider from './common/GlobalDialogProvider';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <BrowserRouter>
            <GlobalDialogProvider>
                <AppRouter />
            </GlobalDialogProvider>
        </BrowserRouter>
    </React.StrictMode>
);

reportWebVitals();

// Register Service Worker for Push Notifications
if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        navigator.serviceWorker
            .register('/service-worker.js')
            .then((registration) => {
            })
            .catch((error) => {
            });
    });
}
